module.exports = __webpack_public_path__ + "static/img/WarmPlate (21).3b1da532.png";